<template>
  <div class="filters-v2">
    <!-- Single row: Search | Filter | Date From | Date To | Add V2 Kit -->
    <div class="filter-row">
      <!-- Search -->
      <div class="search-box">
        <span class="search-icone-wrap left">
          <img src="../../images/header/search_icone.svg" alt="Search" />
        </span>
        <input
          type="text"
          class="search-input"
          id="search-input-v2"
          placeholder="Search"
          @input="setSearchStr"
          @keyup.enter="sendsearchReq"
        />
        <span class="search-icone-wrap right" :class="showClose ? 'right-close' : 'right'">
          <button class="btn-clear" v-if="showClose && searchKey" @click="clearText">
            <CloseIcone class="clear-icon"></CloseIcone>
          </button>
          <img
            v-if="!loading"
            src="../../images/dashboard/refresh.png"
            alt="Refresh"
            @click="sendsearchReq"
          />
          <img
            v-else
            class="loading-gif"
            src="../../images/dashboard/reloading-gif.svg"
            alt="Loading"
          />
        </span>
      </div>

      <!-- Status Filter Dropdown -->
      <div class="filter-wrap" v-click-outside="closeModel">
        <button
          class="btn btn-filter"
          :class="{ open: showFilters }"
          @click="showFilters = !showFilters"
        >
          Filter
        </button>
        <ul class="filter-list-wrap" v-show="showFilters">
          <li class="filter-list-item hide">Status</li>
          <li class="filter-list-item" @click="setFilter(0, 'shipped')" :class="{ active: shipped }">Sold</li>
          <li class="filter-list-item" @click="setFilter(1, 'activated')" :class="{ active: activated }">Activated</li>
          <li class="filter-list-item" @click="setFilter(2, 'awaiting')" :class="{ active: awaiting }">Submitted</li>
          <li class="filter-list-item" @click="setFilter(13, 'dnaExtraction')" :class="{ active: dnaExtraction }">DNA Extraction</li>
          <li class="filter-list-item" @click="setFilter(14, 'sequencing')" :class="{ active: sequencing }">Sequencing</li>
          <li class="filter-list-item" @click="setFilter(3, 'received')" :class="{ active: received }">Lab Received</li>
          <li class="filter-list-item" @click="setFilter(4, 'hold')" :class="{ active: hold }">On Hold</li>
          <li class="filter-list-item" @click="setFilter(5, 'complete')" :class="{ active: complete }">Analysis Complete</li>
          <li class="filter-list-item" @click="setFilter(8, 'archive')" :class="{ active: archive }">Archived</li>
        </ul>
      </div>

      <!-- Date From -->
      <div class="datepickerWrapDiv">
        <Datepicker
          placeholder="Date From"
          v-model="date_from"
          :format="formatDate"
          :disabledDates="disabledDatesFrom"
          :calendar-class="{ calendarWrap: true }"
          :class="{ datepickerWrapAdmin: true }"
          :input-class="{ datepickerInputAdmin: true }"
        ></Datepicker>
        <img src="../../images/dashboard/calendar.png" alt="Calendar" class="datepickerWrapDiv-img" />
        <button class="datepickerWrapDiv-img-cross" v-if="date_from !== null" @click="date_from = null">
          <CloseIcone></CloseIcone>
        </button>
      </div>

      <!-- Date To -->
      <div class="datepickerWrapDiv">
        <Datepicker
          placeholder="Date To"
          v-model="date_to"
          :format="formatDate"
          :disabledDates="disabledDatesTo"
          :calendar-class="{ calendarWrap: true }"
          :class="{ datepickerWrapAdmin: true }"
          :input-class="{ datepickerInputAdmin: true }"
        ></Datepicker>
        <img src="../../images/dashboard/calendar.png" alt="Calendar" class="datepickerWrapDiv-img" />
        <button class="datepickerWrapDiv-img-cross" v-if="date_to !== null" @click="date_to = null">
          <CloseIcone></CloseIcone>
        </button>
      </div>

      <!-- Add V2 Kit Button -->
      <button
        class="btn btn-test"
        @click="addTestKitModalV2"
      >
        Add Dust Kit
      </button>
    </div>

    <!-- Active Filter Tags -->
    <div class="btn-filter-item-wrap" v-if="filters.length > 0">
      <button
        class="btn btn-filter-item"
        v-for="item in filters"
        :key="item"
        :style="{ backgroundColor: filterColorMap[item] }"
      >
        <svg
          @click="resetStatusFilter(item)"
          class="btn-filter-item-cross"
          viewBox="0 0 10 10"
          fill="none"
        >
          <path d="M2 2L8 8M8 2L2 8" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <span class="filter-item-txt" v-if="item === 0">Sold</span>
        <span class="filter-item-txt" v-if="item === 1">Activated</span>
        <span class="filter-item-txt" v-if="item === 2">Submitted</span>
        <span class="filter-item-txt" v-if="item === 3">Received</span>
        <span class="filter-item-txt" v-if="item === 13">DNA Extraction</span>
        <span class="filter-item-txt" v-if="item === 14">Sequencing</span>
        <span class="filter-item-txt" v-if="item === 4">Hold</span>
        <span class="filter-item-txt" v-if="item === 5">Complete</span>
        <span class="filter-item-txt" v-if="item === 7">Delivered</span>
        <span class="filter-item-txt" v-if="item === 8">Archived</span>
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import CloseIcone from "../../images/shared/cancel";

export default {
  name: "FiltersV2",
  data() {
    return {
      step: 0,
      filters: [],
      showFilters: false,
      date_from: null,
      date_to: null,
      shipped: false,
      delivered: false,
      activated: false,
      awaiting: false,
      received: false,
      accepted: false,
      dnaExtraction: false,
      sequencing: false,
      hold: false,
      complete: false,
      archive: false,
      searchKey: null,
      loading: false,
      filterColorMap: {
        0: "#005EB8",  // Shipped
        1: "#F1B434",  // Activated
        2: "#AC75BD",  // Submitted
        3: "#00BBDC",  // Received
        16: "#0EA5E9", // Accepted
        13: "#17A2B8", // DNA Extraction
        14: "#6F42C1", // Sequencing
        4: "#E8833A",  // Hold
        5: "#005EB8",  // Complete
        7: "#98A4AE",  // Delivered
        8: "#58595B"   // Archived
      },
      showClose: false,
      disabledDatesTo: {
        to: null
      },
      disabledDatesFrom: {
        to: null
      }
    };
  },
  components: {
    Datepicker,
    CloseIcone
  },
  computed: {
    ...mapGetters(["role", "getSearchstrV2", "getKitStatusV2"]),
    storeStatusV2() {
      return this.$store.state.adminV2.statusV2;
    },
    storeDateFromV2() {
      return this.$store.state.adminV2.dateFromV2;
    },
    storeDateToV2() {
      return this.$store.state.adminV2.dateToV2;
    }
  },
  watch: {
    getKitStatusV2(val) {
      if (val == null || val == "") {
        this.shipped = false;
        this.delivered = false;
        this.activated = false;
        this.awaiting = false;
        this.received = false;
        this.accepted = false;
        this.dnaExtraction = false;
        this.sequencing = false;
        this.hold = false;
        this.complete = false;
        this.archive = false;
        this.filters = [];
      }
    },
    getSearchstrV2(val) {
      if (val === null || val === "") {
        this.searchKey = null;
        this.showClose = false;
        const el = document.getElementById("search-input-v2");
        if (el) el.value = "";
      }
    },
    storeStatusV2(val) {
      if (val === "") {
        this.shipped = false;
        this.delivered = false;
        this.activated = false;
        this.awaiting = false;
        this.received = false;
        this.accepted = false;
        this.dnaExtraction = false;
        this.sequencing = false;
        this.hold = false;
        this.complete = false;
        this.archive = false;
        this.filters = [];
      }
    },
    storeDateFromV2(val) {
      if (val === null && this.date_from !== null) {
        this.date_from = null;
      }
    },
    storeDateToV2(val) {
      if (val === null && this.date_to !== null) {
        this.date_to = null;
      }
    },
    date_from(newDate) {
      this.$emit("clearOutlier");
      this.disabledDatesTo = {
        to: this.date_from
      };
      if (newDate) {
        newDate = moment(newDate)
          .utc()
          .format("YYYY-MM-DD 00:01:00");
      }
      this.setDateFromV2(newDate);
      this.sendSearchReqV2();
    },
    date_to(newDate) {
      this.$emit("clearOutlier");
      this.disabledDatesFrom = {
        from: this.date_to
      };
      if (newDate) {
        newDate = moment(newDate)
          .utc()
          .format("YYYY-MM-DD 23:59:00");
      }
      this.setDateToV2(newDate);
      this.sendSearchReqV2();
    }
  },
  methods: {
    ...mapActions([
      "setSearchstrV2",
      "sendSearchReqV2",
      "setStatusFilterV2",
      "setDateFromV2",
      "setDateToV2",
      "setPaginationPageV2",
      "resetStateV2"
    ]),
    setSearchStr(e) {
      this.setPaginationPageV2(null);
      this.searchKey = e.target.value;
      const parsed = this.searchKey ? this.searchKey.replace(/-/g, "") : null;
      this.setSearchstrV2(parsed);
    },
    async sendsearchReq() {
      this.$emit("clearOutlier");
      if (document.getElementById("search-input-v2").value !== null) {
        this.showClose = true;
      }
      this.loading = true;
      try {
        await this.sendSearchReqV2();
      } catch (error) {
        console.error("Error searching V2 kits", error);
      } finally {
        this.loading = false;
      }
    },
    clearText() {
      this.showClose = false;
      document.getElementById("search-input-v2").value = "";
      this.searchKey = null;
      this.setSearchstrV2("");
      this.sendSearchReqV2();
    },
    setFilter(statusCode, filterKey) {
      this.$emit("clearOutlier");
      this[filterKey] = !this[filterKey];
      const found = this.filters.indexOf(statusCode);
      if (found !== -1) {
        this.filters.splice(found, 1);
      } else if (typeof statusCode !== "undefined") {
        this.filters.push(statusCode);
      }
      this.setStatusFilterV2(this.filters);
      this.sendSearchReqV2();
    },
    resetStatusFilter(item) {
      this.$emit("clearOutlier");
      switch (item) {
        case 0:
          this.shipped = false;
          break;
        case 1:
          this.activated = false;
          break;
        case 2:
          this.awaiting = false;
          break;
        case 3:
          this.received = false;
          break;
        case 16:
          this.accepted = false;
          break;
        case 13:
          this.dnaExtraction = false;
          break;
        case 14:
          this.sequencing = false;
          break;
        case 4:
          this.hold = false;
          break;
        case 5:
          this.complete = false;
          break;
        case 7:
          this.delivered = false;
          break;
        case 8:
          this.archive = false;
          break;
        default:
          break;
      }
      const found = this.filters.indexOf(item);
      if (this.filters.length !== 0) {
        this.filters.splice(found, 1);
      } else {
        this.filters = [];
      }
      this.setStatusFilterV2(this.filters);
      this.sendSearchReqV2();
    },
    formatDate(date) {
      return moment(date).format("MMM DD, YYYY");
    },
    addTestKitModalV2() {
      this.$emit("showTestKitModalV2", true);
    },
    closeModel() {
      if (this.showFilters) {
        this.showFilters = false;
      }
    }
  },
  mounted() {
    const el = document.getElementById("search-input-v2");
    if (el) {
      el.value = this.$store.getters.getSearchstrV2 || "";
    }
  }
};
</script>

<style scoped>
.filters-v2 {
  width: 100%;
  margin-top: 10px;
}

/* ── Single horizontal row ── */
.filter-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* ── Search Box ── */
.search-box {
  position: relative;
  border-radius: 5px;
  flex: 1;
  min-width: 180px;
  max-width: 320px;
}

.search-input {
  font-size: 14px;
  font-weight: 500;
  font-family: TTNormsMedium, sans-serif;
  width: 100%;
  padding: 8px 50px 8px 38px;
  border: 1px solid #e4e4e4;
  background-color: #fff;
  outline: none;
  border-radius: 5px;
  transition: background-color 0.3s linear;
  box-sizing: border-box;
}

.search-input::placeholder {
  color: #757575;
  font-family: TTNormsLight, sans-serif;
  opacity: 0.8;
}

.search-input:focus {
  background-color: #f5f5f5;
}

.search-icone-wrap {
  position: absolute;
  width: 20px;
  display: flex;
  align-items: center;
}

.search-icone-wrap.left {
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.search-icone-wrap.left img {
  max-width: 70%;
  height: auto;
}

.search-icone-wrap.right {
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.search-icone-wrap.right-close {
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.search-icone-wrap.right img {
  max-width: 100%;
  height: auto;
  cursor: pointer;
}

.loading-gif {
  width: 22px;
  height: auto;
}

.btn-clear {
  margin: 0 5px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  padding: 0;
  border: 1px solid transparent;
  cursor: pointer;
  background-color: transparent;
  color: gray;
}

.clear-icon {
  max-width: 100%;
  height: 100%;
}

/* ── Status Filter Dropdown ── */
.filter-wrap {
  position: relative;
  flex-shrink: 0;
}

.btn {
  cursor: pointer;
  outline: none;
}

.btn-filter {
  background-color: #005eb8;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid #005eb8;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
  padding: 7px 25px;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s linear;
}

.btn-filter.open {
  background-color: #fff;
  color: #005eb8;
  border: 1px solid #005eb8;
}

.btn-filter:hover {
  background-color: #fff;
  color: #005eb8;
  border: 1px solid #005eb8;
}

.filter-list-wrap {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  list-style: none;
  padding: 0;
  margin: 2px 0 0 0;
  min-width: 180px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.filter-list-item {
  padding: 8px 15px;
  cursor: pointer;
  font-size: 14px;
  font-family: TTNormsRegular, sans-serif;
  color: #4f4e4e;
  transition: background-color 0.2s;
}

.filter-list-item:hover {
  background-color: #eaeaea;
}

.filter-list-item.active {
  background-color: #005eb8;
  color: #fff;
}

.filter-list-item.hide {
  font-weight: 600;
  cursor: default;
  color: #999;
  font-family: TTNormsMedium, sans-serif;
}

/* ── Datepickers ── */
.datepickerWrapDiv {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.datepickerWrapAdmin {
  border: 1px solid #e4e4e4;
  border-radius: 5px;
  color: #4d4d4d !important;
  width: 100% !important;
  font-size: 14px !important;
  font-family: TTNormsLight, sans-serif !important;
  text-align: center !important;
  outline: none !important;
}

.datepickerWrapDiv-img {
  position: absolute;
  left: 10px;
  top: 8px;
  max-width: 18px;
  pointer-events: none;
}

.datepickerWrapDiv-img-cross {
  padding: 0;
  cursor: pointer;
  background-color: transparent;
  border: none;
  width: 11px;
  display: flex;
  align-self: center;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 10px;
  height: 11px;
}

/* ── Add V2 Kit Button ── */
.btn-test {
  background-color: #6cc24a;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid transparent;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
  padding: 7px 25px;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s linear;
  white-space: nowrap;
  flex-shrink: 0;
}

.btn-test:hover {
  background-color: transparent;
  color: #6cc24a;
  border: 1px solid #6cc24a;
}

/* ── Active Filter Tags ── */
.btn-filter-item-wrap {
  display: flex;
  gap: 5px;
  margin-top: 10px;
  flex-wrap: wrap;
  width: 100%;
}

.btn-filter-item {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid transparent;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
  padding: 5px 12px;
  cursor: default;
  border-radius: 5px;
}

.btn-filter-item-cross {
  width: 10px;
  height: 10px;
  margin-right: 6px;
  cursor: pointer;
  flex-shrink: 0;
}

.filter-item-txt {
  white-space: nowrap;
}
</style>
